// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".commitCon .el-input{width:9.375vw!important;height:1.875vw!important;margin-left:1.198vw;margin-right:1.198vw;font-size:.729vw!important}.commitCon .el-input .el-input__inner{width:9.375vw!important;height:1.875vw!important;border-radius:1px!important}", ""]);
// Exports
module.exports = exports;
